import { TChainId } from 'modules/api';
import { getWithdrawalStatus } from 'modules/dashboard/actions/getWithdrawalStatus';
import { store } from 'store';

export const useRefetchWithdrawalStatus = (
  address: string | undefined,
  chainId: TChainId,
) => {
  // https://github.com/reduxjs/redux-toolkit/discussions/3512#discussioncomment-7146109
  return () =>
    store.dispatch(
      getWithdrawalStatus.initiate(
        { address, chainId },
        { forceRefetch: true },
      ),
    );
};
